import React from 'react'
import { observer } from 'mobx-react'
import Skeleton from 'react-loading-skeleton'

import { REACT_LOADING_DURATION } from '../../../Loader/constants'

import {
   TaskDetailedViewWrapper,
   TaskTitleUpdateActionLoadingWrapper,
   TaskIdAndActionsLoadingWrapper,
   HeaderLoadingWrapper,
   TaskDescriptionLoadingWrapper,
   TaskFieldsLoadingWrapper,
   FieldLoadingWrapper,
   TaskDescriptionContainer
} from './styledComponents'

class MobileTaskDetailedViewLoader extends React.Component {
   numberOfTaskFields = 4
   renderHeaderLoader = () => (
      <HeaderLoadingWrapper>
         <TaskTitleUpdateActionLoadingWrapper>
            <Skeleton
               duration={REACT_LOADING_DURATION}
               width={316}
               height={30}
               style={{ flexGrow: 1, maxWidth: 384 }}
            />
         </TaskTitleUpdateActionLoadingWrapper>
         <TaskIdAndActionsLoadingWrapper>
            <Skeleton
               duration={REACT_LOADING_DURATION}
               width={100}
               height={24}
            />
            <Skeleton
               duration={REACT_LOADING_DURATION}
               width={80}
               height={15}
               style={{ marginLeft: '1rem' }}
            />
         </TaskIdAndActionsLoadingWrapper>
      </HeaderLoadingWrapper>
   )
   renderTaskDescriptionLoader = () => (
      <TaskDescriptionLoadingWrapper>
         <Skeleton
            duration={REACT_LOADING_DURATION}
            width={100}
            height={14}
            style={{ marginBottom: 12 }}
         />
         <TaskDescriptionContainer>
            <Skeleton
               duration={REACT_LOADING_DURATION}
               width={316}
               height={80}
               style={{ flexGrow: 1, maxWidth: 384 }}
            />
         </TaskDescriptionContainer>
      </TaskDescriptionLoadingWrapper>
   )
   renderTaskFieldsLoader = () => (
      <TaskFieldsLoadingWrapper>
         {Array.from(Array(this.numberOfTaskFields).keys()).map(index => (
            <FieldLoadingWrapper key={index}>
               <Skeleton
                  duration={REACT_LOADING_DURATION}
                  width={100}
                  height={14}
                  style={{ marginBottom: 12 }}
               />
               <Skeleton
                  duration={REACT_LOADING_DURATION}
                  width={320}
                  height={36}
               />
            </FieldLoadingWrapper>
         ))}
      </TaskFieldsLoadingWrapper>
   )
   render() {
      const {
         renderHeaderLoader: RenderHeaderLoader,
         renderTaskDescriptionLoader: RenderTaskDescriptionLoader,
         renderTaskFieldsLoader: RenderTaskFieldsLoader
      } = this
      return (
         <TaskDetailedViewWrapper>
            <RenderHeaderLoader />
            <RenderTaskDescriptionLoader />
            <RenderTaskFieldsLoader />
         </TaskDetailedViewWrapper>
      )
   }
}

export default observer(MobileTaskDetailedViewLoader)
